import React from 'react';

export default function TableLevel({ title }) {
	return (
		<tr>
			<td>&nbsp;</td>
			<td><h3>{title}</h3></td>
		</tr>
	);
}
